import React from "react";
import "./RentPages.module.scss";
import { Helmet } from "react-helmet";
import MapViewPage from "./MapViewPage";
import ListViewPage from "./ListViewPage";
import { useLocation, useNavigate } from "react-router-dom";

interface PropertiesPageProps {}

export function ViewSwitcher({ fullWidth = false }: { fullWidth?: boolean }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isList = location.pathname.endsWith("/list");
  const goTo = (mode: "map" | "list") => {
    const base = "/services/rent/properties";
    const suffix = location.search || "";
    navigate(mode === "map" ? `${base}/map${suffix}` : `${base}/list${suffix}`);
  };
  return (
    <div
      className={fullWidth ? "flex w-full gap-2" : "flex justify-center gap-2"}
    >
      <button
        type="button"
        onClick={() => goTo("map")}
        className={`${
          fullWidth ? "flex-1" : ""
        } px-6 py-1 border border-solid border-[#ddd] cursor-pointer uppercase font-teko text-lg transform transition-all duration-300 ${
          !isList ? "bg-brand-yellow border-brand-yellow text-gray-900" : ""
        }`}
      >
        <span className="block transform">Map View</span>
      </button>
      <button
        type="button"
        onClick={() => goTo("list")}
        className={`${
          fullWidth ? "flex-1" : ""
        } px-6 py-1 border border-solid border-[#ddd] cursor-pointer uppercase font-teko text-lg transform transition-all duration-300 ${
          isList ? "bg-brand-yellow border-brand-yellow text-gray-900" : ""
        }`}
      >
        <span className="block transform">List View</span>
      </button>
    </div>
  );
}

export default function PropertiesPage(
  props: PropertiesPageProps
): JSX.Element {
  const location = useLocation();

  const isList = location.pathname.endsWith("/list");

  return (
    <>
      <Helmet>
        <title>Properties | Letting Engine</title>
        <meta
          name="description"
          content="Browse properties to rent with map and list views."
        />
      </Helmet>
      <div className={"properties-page mt-[70px]"}>
        {isList ? <ListViewPage /> : <MapViewPage />}
      </div>
    </>
  );
}
